import React, { useState, useEffect } from 'react';
import '@/App.css';
import { Navigation } from '@/components/Navigation';
import { Home } from '@/components/Home';
import { About } from '@/components/About';
import { Certifications } from '@/components/Certifications';
import { BugList } from '@/components/BugList';
import { Contact } from '@/components/Contact';

function Portfolio() {
  const [activeSection, setActiveSection] = useState('home');

  useEffect(() => {
    const handleScroll = () => {
      const sections = ['home', 'about', 'certifications', 'bugs', 'contact'];
      const scrollPosition = window.scrollY + 200;

      for (const section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const { offsetTop, offsetHeight } = element;
          if (scrollPosition >= offsetTop && scrollPosition < offsetTop + offsetHeight) {
            setActiveSection(section);
            break;
          }
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavigate = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      });
    }
  };

  return (
    <div className="App smooth-scroll" data-testid="main-app">
      <Navigation activeSection={activeSection} onNavigate={handleNavigate} />
      <Home />
      <About />
      <Certifications />
      <BugList isAdmin={false} />
      <Contact />
    </div>
  );
}

export default Portfolio;
